import {Backbone} from 'Vertebrae';
import {AlgorithmUser} from 'model/algorithmUser';

export const AlgorithmUsers = Backbone.Collection.extend({
    _name: 'Experts',
    model: AlgorithmUser,
    url: '/registration/search/results.json',
});
